export const getFaxStatusColor = (status?: string): string => {
  switch (status) {
    case "sending":
      return "processing";
    case "delivered":
    case "complete":
      return "success";
    case "deleted":
      return "default";
    default:
      return "error";
  }
};